module.exports = __webpack_public_path__ + "static/media/left_drive.5aa6f61e.png";